var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
var MenuLateralItem = React.forwardRef(function (_a, ref) {
    var Component = _a.as, children = _a.children, isLienActif = _a.isLienActif, className = _a.className, onClick = _a.onClick, otherProps = __rest(_a, ["as", "children", "isLienActif", "className", "onClick"]);
    if (!Component) {
        Component = "a";
    }
    var aClassName = "fr-sidemenu__link";
    if (className) {
        aClassName += " ".concat(className);
    }
    var liClassName = "fr-sidemenu__item";
    var propsAriaCurrent = {};
    if (isLienActif) {
        liClassName += " fr-sidemenu__item--active";
        propsAriaCurrent['aria-current'] = "page";
    }
    return (React.createElement("li", { className: liClassName },
        React.createElement(Component, __assign({ ref: ref, className: aClassName, onClick: onClick }, propsAriaCurrent, otherProps), children)));
});
MenuLateralItem.defaultProps = {
    as: 'a',
};
export default MenuLateralItem;
